import MergeEvaluation from './src/main';

/* istanbul ignore next */
MergeEvaluation.install = function(Vue) {
  Vue.component(MergeEvaluation.name, MergeEvaluation);
};

export default MergeEvaluation;
